import { render, staticRenderFns } from "./CreateField.vue?vue&type=template&id=7ef95db7&lang=pug"
import script from "./CreateField.vue?vue&type=script&lang=js"
export * from "./CreateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports